import { render, staticRenderFns } from "./Notifikasi.vue?vue&type=template&id=1dc44c45&scoped=true"
import script from "./Notifikasi.vue?vue&type=script&lang=js"
export * from "./Notifikasi.vue?vue&type=script&lang=js"
import style0 from "./Notifikasi.vue?vue&type=style&index=0&id=1dc44c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc44c45",
  null
  
)

export default component.exports